
@if (!viewOnly) {
<div class="container">
    <div class="row">
        <div class="col-4">
            <p><b>Esikatsele sähköpostipohjaa:</b><br>
            Valitse sähköpostipohja, ja klikkaa Lataa.</p>
        </div>
        <div class="col-4">
            <p-select [options]="emails" [(ngModel)]="selectedEmail" optionLabel="name" placeholder="Select an email" class="" />
        </div>
        <div class="col-4">
            <p-button (click)="loadEmail()">Lataa</p-button>
        </div>

    </div>
</div>
}


<div class="container mt-3">
    @if (showError) {
    <p-message severity="error">Sähköpostipohjaa ei löytynyt.</p-message>

    }
    @if (content) {
    @if (viewOnly) {
    <iframe class="viewonly-frame" [attr.srcdoc]="content"></iframe>
    } @else {
    <iframe [attr.srcdoc]="content" style="width: 100%; border: 1px solid #ccc; height: 90vh;"></iframe>
    }
    }

</div>
